import { render, staticRenderFns } from "./approve-reject.vue?vue&type=template&id=6a22b4ba&scoped=true&lang=pug"
import script from "./approve-reject.vue?vue&type=script&lang=ts"
export * from "./approve-reject.vue?vue&type=script&lang=ts"
import style0 from "./approve-reject.vue?vue&type=style&index=0&id=6a22b4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22b4ba",
  null
  
)

export default component.exports